import { render, staticRenderFns } from "./SampleOrderDetailsView.vue?vue&type=template&id=6f7ed125&scoped=true&"
import script from "./SampleOrderDetailsView.vue?vue&type=script&lang=js&"
export * from "./SampleOrderDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./SampleOrderDetailsView.vue?vue&type=style&index=0&id=6f7ed125&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7ed125",
  null
  
)

export default component.exports